import { useEffect, useState } from "react";
import {
  ClassResponse,
  TestResponse,
} from "../../services/api.response.service";
import { Button, Col, Row } from "react-bootstrap";
import SubscribeAccessButton from "./SubscribeAccessButton";
import { ReactComponent as CheckSquare } from "../../assets/svg/CheckSquare.svg";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { RouteEndpoints } from "../../services/route.service";
import { getLanguageByDefault } from "../../services/app.service";
import ClassTabsView from "./ClassTabsView";
import CertificateModal from "../CertificateModal";
import ContentProviderCardSmall from "../ContentProviderCardSmall";
import CourseBundleCard, {
  CourseBundleData,
} from "./CourseBundleCard";
import Api from "../../services/api.service";
import { getBundlePayUrl } from "../../services/app.service";

interface props {
  classDetails: ClassResponse;
  // contents: Array<ContentResponse>;
  tests: TestResponse[];
  tab: any;
}

const ClassDetailsView = ({
  classDetails,
  // contents,
  tests,
  tab,
}: props) => {
  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const getLanguage = getLanguageByDefault();

  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [classBundleOffer, setClassBundleOffer] =
    useState<CourseBundleData | null>(null);

  useEffect(() => {
    const classId = classDetails?.id;
    if (classId == null) {
      setClassBundleOffer(null);
      return;
    }
    let cancelled = false;
    Api.getClassBundlesForClass(classId)
      .then((res) => {
        if (cancelled) return;
        const list = res.data?.data;
        if (!Array.isArray(list)) {
          setClassBundleOffer(null);
          return;
        }
        const icons = [
          "las la-bolt",
          "las la-dna",
          "las la-atom",
          "las la-link",
          "las la-leaf",
          "las la-flask",
          "las la-book",
          "las la-graduation-cap",
        ];
        for (const b of list) {
          if (!b?.is_active) continue;
          const cls = Array.isArray(b.classes) ? b.classes : [];
          if (cls.length === 0) continue;
          const bundleFullyPaid =
            cls.length > 0 && cls.every((c: { has_paid?: boolean }) => c.has_paid === true);
          if (bundleFullyPaid) continue;
          const sumMonth = cls.reduce(
            (s: number, c: { subscription_amount_month?: number }) =>
              s + (Number(c.subscription_amount_month) || 0),
            0,
          );
          const bundleMonth = Number(b.subscription_amount_month) || 0;
          const currency =
            b.subscription_currency ||
            classDetails.subscription_currency ||
            "USD";
          const showCompare = sumMonth > bundleMonth;
          setClassBundleOffer({
            id: b.id,
            name: b.name || "Bundle",
            providerName:
              classDetails?.content_provider?.name ?? "eCampus Education",
            originalPrice: showCompare ? sumMonth : bundleMonth,
            discountedPrice: bundleMonth,
            currency,
            courses: cls.map(
              (c: { name?: string }, i: number) => ({
                name: c.name || "",
                icon: icons[i % icons.length],
              }),
            ),
            imageUrl: cls[0]?.logo_url,
            bundlePayUrl: getBundlePayUrl(String(b.id)),
            showComparePrice: showCompare,
          });
          return;
        }
        setClassBundleOffer(null);
      })
      .catch(() => {
        if (!cancelled) setClassBundleOffer(null);
      });
    return () => {
      cancelled = true;
    };
  }, [classDetails?.id, classDetails?.subscription_currency]);

  const handleCloseCertificateModal = () => setShowCertificateModal(false);
  const handleShowCertificateModal = () => setShowCertificateModal(true);

  // const tab = location.hash.replace("#", "");
  return (
    <>
      <div className="">
        <Col sm={12}>
          <div className="card course-card-hero d-flex align-items-center justify-content-center">
            <img src={classDetails?.logo_url} alt="story-img" />
          </div>

          {/*<div className="card course-card-hero d-flex align-items-center justify-content-center">*/}
          {/*    <img src={bg} alt="story-img" />*/}
          {/*</div>*/}

          <div className="course-details">
            <div className="w-100">
              <div className="d-flex flex-column gap-1">
                {/*for class details,  description, goals, skills, and other details*/}
                <div className="row col-12">
                  {/*for class details,  description, goals, skills, and other details*/}
                  <div className=" col-md-9 ">
                    {/*for name, category and language*/}
                    <>
                      <div className="d-flex flex-column justify-content-md-between gap-3 pb-2 gap-md-0 pb-md-0">
                        <div className="d-flex justify-content-start align-items-start gap-2">
                          {/*<img src={classDetails?.logo_url}*/}
                          {/*     alt="story-img" width={50}*/}
                          {/*/>*/}
                          <div className="d-flex flex-column gap-1  w-100">
                            <h4
                              style={{ fontSize: "25px", fontWeight: 600 }}
                              className="mt-1"
                            >
                              {" "}
                              {classDetails?.name}
                            </h4>

                            <div className="mt-1 row col-12">
                              {/*<Card className="d-flex justify-content-center align-items-center user-card p-1">*/}
                              {/*  <small>Subscription per month</small>*/}
                              {/*  <h6*/}
                              {/*      style={{color: "#DA3732"}}*/}
                              {/*      className="font-weight-bold"*/}
                              {/*  >*/}
                              {/*    {classDetails?.subscription_currency} {classDetails?.subscription_amount_month}*/}
                              {/*  </h6>*/}
                              {/*</Card>*/}
                              <div
                                className="col-sm-3 text-center align-items-center
                                                                 p-1 m-1 course-card-container"
                              >
                                <small>{getLanguage.category}</small>
                                <br />
                                <h6>{classDetails?.category?.name ?? "NA"}</h6>
                              </div>
                              <div
                                className="col-sm-3 text-center align-items-center
                                                                  m-1 p-1 course-card-container"
                              >
                                <small>{getLanguage.language}</small>
                                <br />
                                <h6>{classDetails?.language ?? "NA"}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>

                    {/*description, goals, skills, and other details*/}
                    {classDetails && classDetails?.goals?.length > 1 && (
                      <>
                        <hr className="ec-hr" />
                        <div>
                          <h5 className="header-fw">
                            {getLanguage.learningGoals}:
                          </h5>
                          <div className="d-flex w-100">
                            <Row>
                              {classDetails?.goals.map((goal, index) => (
                                <Col
                                  sm={6}
                                  key={index}
                                  className="d-flex justify-content-start align-items-start"
                                >
                                  <CheckSquare
                                    className="col-1"
                                    style={{
                                      textAlign: "center",
                                      marginTop: "10px",
                                    }}
                                  />

                                  <p className="col-11 text-muted m-1 details-fw">
                                    {goal}
                                  </p>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </div>
                      </>
                    )}
                    {classDetails && classDetails?.skills?.length > 1 && (
                      <>
                        <hr className="ec-hr" />
                        <div>
                          <h5 className="header-fw">{getLanguage.skills}:</h5>
                          <div
                            className="d-grid d-md-flex flex-wrap gap-2
                                                        justify-content-start align-items-center"
                          >
                            {classDetails?.skills.map((skill, index) => (
                              <span
                                key={index}
                                className="skills-btn d-flex justify-content-center align-items-center details-fw mt-1"
                              >
                                {" "}
                                {skill}{" "}
                              </span>
                            ))}
                          </div>
                        </div>
                      </>
                    )}

                    <>
                      <hr className="ec-hr" />
                      <div>
                        <h5 className="header-fw">
                          {getLanguage.aboutThisClass}:
                        </h5>
                        <p className="text-muted details-fw">
                          {classDetails?.description ?? "NA"}
                        </p>
                      </div>
                    </>

                    {/*{*/}
                    {/*    (classDetails && classDetails?.goals?.length > 1) &&*/}
                    {/*    (*/}
                    {/*        <>*/}
                    {/*        </>*/}
                    {/*    )*/}
                    {/*}*/}

                    <hr className="ec-hr" />

                    <ClassTabsView
                      classDetails={classDetails}
                      // contents={contents}
                      tests={tests}
                      tab={tab}
                      // handleSetCourse={handleSetCourse}
                    />

                    <hr className="ec-hr" />
                  </div>

                  {/*for totals and subscribers*/}
                  <div className=" col-md-3  " style={{}}>
                    <div className="card ec-card d-flex justify-content-center user-card p-3">
                      {!classDetails?.is_free &&
                      (!classDetails?.is_subscribed ||
                        (classDetails?.is_subscribed &&
                          !classDetails?.has_paid)) ? (
                        <div className="d-grid d-md-flex justify-content-evenly gap-1">
                          <span className="mt-2">Price per month</span>
                          <span
                            style={{
                              color: "#0D6364",
                              fontSize: "25px",
                              fontWeight: "500",
                            }}
                            className=""
                          >
                            {classDetails?.subscription_currency}{" "}
                            {classDetails?.subscription_amount_month}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="d-flex flex-column justify-content-center align-items-center ">
                        {currentUser?.ecampus_id &&
                        classDetails?.is_subscribed &&
                        classDetails?.has_paid ? (
                          // && contents && contents?.length > 0
                          ""
                        ) : (
                          // <a
                          //     href={RouteEndpoints.COURSE_CONTENT((String)(contents?.pop()?.id ?? ''))}
                          //     className="text-decoration-none btn btn-primary ec-btn"
                          //     rel="noreferrer"
                          // >
                          //     {getLanguage.clickHereToAccessContent}
                          // </a>

                          <>
                            <SubscribeAccessButton
                              classDetails={classDetails}
                            />
                          </>
                        )}
                      </div>
                      {/* <Button
                                                type="button"
                                                className="btn btn-primary ec-btn"
                                                onClick={handleShowCertificateModal}

                                            >{getLanguage.viewCertificate}</Button> */}

                      <hr className="ec-hr" />
                      <h5 className="header-fw">{getLanguage.whatYouGet}:</h5>
                      <div className="d-flex flex-column justify-content-between w-100">
                        {!(
                          classDetails?.total_courses == undefined ||
                          classDetails?.total_courses == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <i className="mt-1 las la-users fs-4"></i>
                            <p className="m-1">
                              {classDetails?.total_courses ?? 0}
                              {(classDetails?.total_courses ?? 0) > 0
                                ? ""
                                : ""}{" "}
                              {getLanguage.sections}
                            </p>
                          </div>
                        )}

                        {!(
                          classDetails?.total_topics == undefined ||
                          classDetails?.total_topics == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <i className="mt-1 las la-users fs-4"></i>
                            <p className="m-1">
                              {classDetails?.total_topics ?? 0}
                              {(classDetails?.total_topics ?? 0) > 0
                                ? ""
                                : ""}{" "}
                              {getLanguage.topics}
                            </p>
                          </div>
                        )}

                        {!(
                          classDetails?.total_videos == undefined ||
                          classDetails?.total_videos == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <i className="mt-1 las la-video fs-4"></i>
                            <p className="m-1">
                              {classDetails?.total_videos ?? 0}{" "}
                              {getLanguage.videos}
                            </p>
                          </div>
                        )}

                        {!(
                          classDetails?.total_audios == undefined ||
                          classDetails?.total_audios == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <i className="mt-1 las la-music fs-4"></i>
                            <p className="m-1">
                              {classDetails?.total_audios ?? 0}{" "}
                              {getLanguage.audios}
                            </p>
                          </div>
                        )}
                        {!(
                          classDetails?.total_questions == undefined ||
                          classDetails?.total_questions == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <i className="mt-1 las la-question fs-4"></i>
                            <span className="m-1">
                              {classDetails?.total_questions ?? 0}
                              {(classDetails?.total_questions ?? 0) > 0
                                ? ""
                                : ""}{" "}
                              {getLanguage.practiceQuestions}
                            </span>
                          </div>
                        )}

                        {!(
                          classDetails?.total_tests == undefined ||
                          classDetails?.total_tests == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <i className="mt-1 las la-file-alt fs-4"></i>
                            <span className="m-1">
                              {classDetails?.total_tests ?? 0}
                              {(classDetails?.total_tests ?? 0) > 0
                                ? ""
                                : ""}{" "}
                              {getLanguage.timedTests}
                            </span>
                          </div>
                        )}

                        <div className="d-grid d-flex gap-1">
                          <i className="mt-1 las la-clock fs-4"></i>
                          <span className="m-1">
                            {classDetails?.runtime ?? 5} {getLanguage.minutes}{" "}
                            {getLanguage.read}{" "}
                          </span>
                        </div>

                        {!(
                          true ||
                          classDetails?.total_subscribers == undefined ||
                          classDetails?.rating == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mt-1 fs-4"
                            >
                              <path
                                d="M7.90219 11.4222L7.5 11.1667L7.09781 11.4222L3.98551 13.3995L4.81994 9.61134L4.9131 9.18839L4.59336 8.89628L1.7613 6.309L5.4603 5.97325L5.91669 5.93182L6.08808 5.50681L7.5 2.00542L8.91192 5.50681L9.08331 5.93182L9.5397 5.97325L13.2366 6.30881L10.3996 8.89582L10.0788 9.18838L10.1728 9.61228L11.0117 13.3978L7.90219 11.4222Z"
                                stroke="#9E9E9E"
                                strokeWidth="1.5"
                              />
                            </svg>{" "}
                            <span className="m-1">
                              {classDetails?.rating ?? 0} overall ratings
                            </span>
                          </div>
                        )}
                        {!(
                          true ||
                          classDetails?.total_subscribers == undefined ||
                          classDetails?.total_subscribers == 0
                        ) && (
                          <div className="d-grid d-flex gap-1">
                            <svg
                              width="20"
                              height="17"
                              viewBox="0 0 20 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mt-1 fs-4"
                            >
                              <path
                                d="M14.0909 16V14.3333C14.0909 13.4493 13.7461 12.6014 13.1323 11.9763C12.5186 11.3512 11.6862 11 10.8182 11H4.27273C3.40475 11 2.57231 11.3512 1.95856 11.9763C1.3448 12.6014 1 13.4493 1 14.3333V16"
                                stroke="#9E9E9E"
                                strokeWidth="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M7.54568 7.66667C9.35315 7.66667 10.8184 6.17428 10.8184 4.33333C10.8184 2.49238 9.35315 1 7.54568 1C5.7382 1 4.27295 2.49238 4.27295 4.33333C4.27295 6.17428 5.7382 7.66667 7.54568 7.66667Z"
                                stroke="#9E9E9E"
                                strokeWidth="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M19 16.0001V14.3334C18.9994 13.5948 18.7581 12.8774 18.3138 12.2937C17.8696 11.7099 17.2475 11.293 16.5454 11.1084M13.2727 1.1084C13.9767 1.29198 14.6006 1.70898 15.0462 2.29366C15.4918 2.87833 15.7337 3.59742 15.7337 4.33757C15.7337 5.07771 15.4918 5.7968 15.0462 6.38147C14.6006 6.96615 13.9767 7.38315 13.2727 7.56673"
                                stroke="#9E9E9E"
                                strokeWidth="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>

                            <span className="m-1">
                              {
                                // Formatter(
                                classDetails?.total_subscribers ??
                                  // )
                                  "NA"
                              }{" "}
                              Subscribers
                            </span>
                          </div>
                        )}
                      </div>

                      <hr className="ec-hr" />
                      <h5 className="header-fw">
                        {getLanguage.learningPartner}:
                      </h5>
                      <div className="d-flex flex-column justify-content-between w-100 mt-1">
                        {/*content provider details*/}
                        {/*<div className="d-flex flex-column justify-content-start align-items-start gap-1 course-sub-details">*/}
                        <ContentProviderCardSmall
                          data={classDetails?.content_provider!}
                        />
                        {/*</div>*/}
                      </div>
                    </div>
                    {classBundleOffer && (
                      <CourseBundleCard
                        classDetails={classDetails}
                        bundle={classBundleOffer}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </div>
      <CertificateModal
        show={showCertificateModal}
        onHide={handleCloseCertificateModal}
        classDetails={classDetails}
      />
    </>
  );
};

export default ClassDetailsView;
